import React from 'react'

import { useQueryParams } from 'raviger'
import Separator from 'Components/shared/Separator'
import CreateVirtualOfficeForm from './Forms/Create'
import VirtualOfficeTable from './Table'
import VirtualOffice from './VirtualOffice'

export default () => {
  const [{ id }] = useQueryParams()

  return id ? (
    <VirtualOffice />
  ) : (
    <>
      <CreateVirtualOfficeForm />
      <Separator />
      <VirtualOfficeTable />
    </>
  )
}
